import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { NominatimResponse } from 'src/app/shared/models/api-response/nominatim-response';
import {
	AbstractControl,
	FormControl,
	FormGroup,
	ValidationErrors,
	ValidatorFn,
	Validators
} from '@angular/forms';
import { Address } from 'src/app/shared/models/address';
import { Observable, of, Subscriber } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Expertise } from 'src/app/shared/models/expertise';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Prestation } from 'src/app/shared/models/prestation';

@Component({
	selector: 'app-prestation-modal-choose-intervenant',
	templateUrl: './prestation-modal-choose-intervenant.component.html',
	styleUrls: ['./prestation-modal-choose-intervenant.component.scss']
})
export class PrestationModalChooseIntervenantComponent implements OnInit {

	@Input() selectedAddress: Address;
	@Input() selectedExpertises: Expertise[];
	@Input() isValidateButtonClicked: { value: boolean };
	@Output() sendForm: EventEmitter<any> = new EventEmitter();
	@Output() hideModal: EventEmitter<any> = new EventEmitter();
	@Input() form: FormGroup;

	/**
	 * Signal émis lors de l'envoi du formulaire pour que la sauvegarde du formulaire ce fasse dans le composant parent
	 */
	//@Output() sendForm: EventEmitter<any> = new EventEmitter();

	/**
	 * Signal émis pour que la modal soit fermée
	 */
	//@Output() hideModal: EventEmitter<any> = new EventEmitter();

	@Input() selectedTypePrestation;

	/**
	 * Addresse selectionner
	 */
	selectedaddress?: Address;

	/**
	 * Typeahead des adresse en chargement
	 */
	typeaheadLoading?: boolean;

	/**
	 * Liste des adresse disponibles dans le typeahead
	 */
	addressList: Observable<NominatimResponse[]>;

	formChooseIntervenant = new FormGroup({
		address: new FormControl(null, [
			Validators.required,
			//Validators.maxLength(60)
		]),
		//dateDebut: new FormControl<Date>(null),
	});

	/**
	 * Liste des adresse récupérer grace au backend
	 */
	searchResults: NominatimResponse[];

	listExpertise: Expertise[];
	listSelectedExpertise: Expertise[];

	//isValidateButtonClicked: { value: boolean } = { value: false };

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };
	@Output() updateListing = new EventEmitter();

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService,
		private cache: CacheService
	) {
		this.addressList = new Observable((observer: Subscriber<string>) => {
			// Runs on every search
			observer.next(this.formChooseIntervenant.value.address);
		}).pipe(
			mergeMap((token: string) =>
				this.getNominatimDisplaynameAsObservable(token)
			)
		);
	}

	ngOnInit(): void {
			this.facade.expertiseService.getExpertisesByServiceAndTypePrestation(this.facade.dataStorageService.getService()?.id, this.selectedTypePrestation).subscribe({
				next: (val) => {
					this.listExpertise = val;
				},
				error: (err) => {
					this.logger.error(err);
				}
			});

			this.listSelectedExpertise = [];

	}

	isExpertiseCheck(spec: Expertise): boolean {
		return this.listSelectedExpertise?.some(
			(specItfc) => specItfc.id === spec.id
		);
	}

	updateSelectedExpertise(e: any, spe: Expertise) {
		if (e.target.checked) {
			if (!this.listSelectedExpertise?.some((z) => z.id === spe.id)) {
				this.listSelectedExpertise?.push(spe);
			}
		} else {
			if (this.listSelectedExpertise.some((z) => z.id === spe.id)) {
				this.listSelectedExpertise = this.listSelectedExpertise.filter(
					(z) => z.id !== spe.id
				);
			}
		}
	}

	/**
	 * Méthode appeler lors de la sélection d'un élément dans le typeahead
	 * @param event
	 */
	onAddressSelect(event: TypeaheadMatch) {
		this.isAddressDefault.value = false;
		this.isAddressSelected.value = true;
		this.selectedaddress = new Address();
		this.selectedaddress.label = event.item.displayName;
		this.selectedaddress.latitude = event.item.latitude;
		this.selectedaddress.longitude = event.item.longitude;
		this.formChooseIntervenant.controls['address'].updateValueAndValidity();
	}

	getNominatimDisplaynameAsObservable(
		token: string
	): Observable<NominatimResponse[]> {
		this.isAddressSelected.value = false;
		this.facade.nominatimService.addressLookup(token).subscribe({
			next: (result: any) => {
				this.searchResults = result.features.map(
					(feature) =>
						new NominatimResponse(
							feature.geometry.coordinates[0],
							feature.geometry.coordinates[1],
							feature.properties.label
						)
				);
			},
			error: (err) => {
				this.logger.log(
					'' + err.status + ' ' + err.error.message ? err.error.message : ''
				);
			}
		});
		return of(this.searchResults);
	}

	changeTypeaheadLoading(e: boolean): void {
		this.typeaheadLoading = e;
	}

	/**
	 * Fonction appelée si une adresse commence à être tapée.
	 */
	selectedAddressKeyUp(e: any) {
		this.isAddressDefault.value = false;
		if (this.selectedaddress && this.selectedaddress.latitude != 0) {
			if (this.selectedaddress?.label === e.value) {
				this.isAddressSelected.value = true;
			}
		}else{
			this.selectedaddress = new Address();
			this.selectedaddress.label = e.value
			this.isAddressSelected.value = true;
		}
		this.formChooseIntervenant.controls['address'].updateValueAndValidity();
	}

	/**
	 * Méthode d'envoie de formulaire, si celui est valide stock les données et envoie un signal au composant parent
	 */
	submitFormChooseIntervenant() {
		if (this.formChooseIntervenant.valid) {
			console.log(this.formChooseIntervenant.value.address)
			console.log(this.listSelectedExpertise)
			this.selectedAddress = this.formChooseIntervenant.value.address;
			this.selectedExpertises = this.listSelectedExpertise;
			this.bsModalRef.hide();
			this.sendForm.emit();
		}
	}

	get address() {
		return this.formChooseIntervenant.get('address');
	}
	// get dateDebut() {
	// 	return this.form?.get('dateDebut');
	// }
	get expertises() {
		return this.formChooseIntervenant?.get('expertises');
	}


	isAddressValidValidator(): ValidatorFn {
		return (control: AbstractControl): ValidationErrors | null => {
			return !(this.isAddressDefault.value || this.isAddressSelected.value)
				? { invalidAddress: { value: control.value } }
				: null;
		};
	}

}
